import ServiceBenefits from './ServiceBenefits';

export default ServiceBenefits;



// WEBPACK FOOTER //
// ./src/components/molecules/ServiceBenefits/index.js